import { vehiclelogs } from "../features/vehiclelogs/Vehiclelogs";
interface Field {
    title: string;
    name: keyof vehiclelogs;
    type: string;
    width: number;
    height?: number;
    isRequired: boolean;
    options?: string[];
}

export const Vehiclelogfields: Field[] = [
    {
        title: "Log No",
        name: "logno",
        type: "text",
        width: 450,
        height: 70,
        isRequired: false,
    },
    {
        title: "Project Name",
        name: "projectname",
        type: "dropDown",
        width: 450,
        isRequired: false,
        height: 70,
        options: [],
    },
    {
        title: "Vehicle",
        name: "vehicle",
        type: "text",
        width: 450,
        height: 70,
        isRequired: false,
    },
    {
        title: "Created By",
        name: "createdby",
        type: "text",
        height: 70,
        width: 350,
        isRequired: false,
    },
    {
        title: "Purpose",
        name: "purpose",
        type: "text",
        width: 450,
        height: 70,
        isRequired: false,
    },
    {
        title: "Created Date",
        name: "createddate",
        type: "date",
        height: 70,
        width: 450,
        isRequired: false,
    },
    {
        title: "Assigned To",
        name: "assignedto",
        type: "dropDown",
        width: 450,
        height: 70,
        isRequired: false,
        options: [],
    },
    {
        title: "Total Distance(kms)",
        name: "totaldistance",
        type: "text",
        width: 450,
        height: 70,
        isRequired: false,
    },
    {
        title: " Description",
        name: "description",
        type: "textArea",
        width: 450,
        height: 5,
        isRequired: false,
    },
    {
        title: " Remarks",
        name: "remarks",
        type: "textArea",
        width: 450,
        height: 5,
        isRequired: false,
    },
    {
        title: "Start Location",
        name: "startlocation",
        type: "textArea",
        width: 450,
        height: 70,
        isRequired: false,
    },
    {
        title: "Signature",
        name: "signature",
        type: "textArea",
        width: 450,
        height: 75,
        isRequired: false,
    },
    {
        title: "Attachments",
        name: "attachments",
        type: "dropzone",
        width: 450,
        height: 100,
        isRequired: false,
    },

];